import { DashboardFilterType } from "../models/dashboard.interface";
import { IActionBase } from '../models/root.interface';
import { SET_OVERVIEW_FILTER, SET_CREDIT_FILTER } from "../actions/dashboard.action";


const initialState: DashboardFilterType = {
    overviewFilterKey: "4",
    creditFilterKey: "4"
};

function DashboardReducer(state: DashboardFilterType = initialState, action: IActionBase): DashboardFilterType {
    switch (action.type) {
        case SET_OVERVIEW_FILTER: {
            return { ...state, overviewFilterKey: action.filterKey };
        }
        case SET_CREDIT_FILTER: {
            return { ...state, creditFilterKey: action.filterKey };
        }
        default:
            return state;
    }
}


export default DashboardReducer;